import {
  Button,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
const COLORS = {
  primary: "#0066CC",
  primaryHover: "#004D99",
  dark: "#1A2025",
  mid: "#4D5F6E",
  light: "#F5F7F9",
  bg: "#F6F7F0",
  bgHover: "#E8ECEF",
  border: "#1A2025",
  white: "#FFFFFF",
  inputBg: "#F6F7F0",
  iconBg: "#F8FBFC",
  iconHover: "#C2E0FF",
};
export const styles = {
  dialog: {
    "& .MuiDialog-paper": {
      maxWidth: "800px",
      borderRadius: "12px",
      position: "relative",
      pt: "25px",
    },
    "& .MuiDialogTitle-root": {
      position: "relative",
      zIndex: 1,
      p: "0px 24px 12px 24px",
    },
    "& .MuiDialogContent-root": {
      position: "relative",
      zIndex: 1,
      p: "0px 20px 24px 20px",
    },
  },
  dialogTitle: {
    color: COLORS.dark,
    fontSize: "18px",
    lineHeight: "140%",
    fontWeight: 600,
  },
  button: {
    base: {
      minWidth: "120px",
      height: "44px",
      borderRadius: "30px",
      fontSize: "14px",
      fontWeight: 500,
      textTransform: "capitalize",
      boxShadow: "none",
      mb: 2,
    },
    submit: {
      background: COLORS.primary,
      color: COLORS.white,
      mr: 1.5,
      "&:hover": { background: COLORS.primaryHover, boxShadow: "none" },
    },
    cancel: {
      background: COLORS.white,
      color: COLORS.dark,
      border: `1px solid ${COLORS.border}`,
      "&:hover": { background: COLORS.light },
    },
  },
  icon: {
    height: "20px",
    width: "20px",
    borderRadius: "50%",
    background: COLORS.iconBg,
    p: "16px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": { background: COLORS.iconHover },
  },
  feedbackInput: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: COLORS.inputBg,
      borderRadius: "8px",
      "& fieldset, &:hover fieldset, &.Mui-focused fieldset": {
        borderColor: COLORS.inputBg,
      },
    },
    "& .MuiOutlinedInput-input": { color: "#1A2025", caretColor: "#0066CC" },
    "& .MuiOutlinedInput-input::placeholder": {
      color: "#1A2025",
      opacity: 0.7,
    },
  },
};
const submitBtn = { ...styles.button.base, ...styles.button.submit };
const cancelBtn = { ...styles.button.base, ...styles.button.cancel };
export const FeedbackDialog = ({
  open,
  onClose,
  title,
  subTitle,
  feedbackComment,
  setFeedbackComment,
  onSubmit,
  loading,
  buttonLabel,
  minRows,
  placeholder,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="sm"
    sx={styles.dialog}
  >
    <DialogTitle sx={styles.dialogTitle}>{title}</DialogTitle>
    <DialogContent sx={{ pt: 1 }}>
      {subTitle && (
        <Typography variant="body2" sx={{ color: "#1A2025", mb: 2, ml: 0.5 }}>
          What could have been better?
        </Typography>
      )}
      <TextField
        autoFocus
        fullWidth
        multiline
        minRows={minRows}
        placeholder={placeholder}
        value={feedbackComment}
        onChange={(e) => setFeedbackComment(e.target.value)}
        sx={{
          ...styles.feedbackInput,
          background: "#F6F7F0",
          color: "#1A2025",
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "#D9E1E7", // default border
            },
            "&:hover fieldset": {
              borderColor: "#0066CC",
            },
            "&.Mui-focused fieldset": {
              border: "1px solid #0066CC", // focused border
            },
          },
        }}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading} sx={cancelBtn}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onSubmit}
        disabled={loading || !feedbackComment.trim()}
        sx={submitBtn}
      >
        {loading ? "Submitting..." : buttonLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
